export default function Disclaimer() {
  return (
    <main className="min-h-screen bg-background-deep px-4 py-10 pb-24 text-white md:px-10">
      <section className="mx-auto max-w-4xl">
        <p className="mb-3 text-xs font-black uppercase tracking-[0.28em] text-primary-glow">
          Vibe2Nite
        </p>

        <h1 className="text-4xl font-black md:text-6xl">
          Disclaimer
        </h1>

        <p className="mt-4 text-white/60">
          Last updated: June 2026
        </p>

        <div className="mt-8 space-y-8 leading-8 text-white/70">
          <section>
            <h2 className="text-2xl font-black text-white">
              Venue Information
            </h2>
            <p className="mt-3">
              Vibe2Nite provides venue information, vibe scores, opening hours,
              photos, directions, categories, event details and local nightlife
              recommendations to help users discover places to go.
            </p>
            <p className="mt-3">
              We aim to keep information useful and up to date, but venue
              details may change without notice. Opening hours, event times,
              prices, offers, availability, entry rules and venue services should
              be confirmed directly with the venue before making plans.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white">
              Events and Offers
            </h2>
            <p className="mt-3">
              Events, live music, sports screenings, restaurant specials, tapas
              nights, happy hours and other offers may be changed, cancelled or
              updated by venues. Vibe2Nite is not responsible for cancelled
              events, changed times, entry refusal, pricing changes or venue
              decisions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white">
              Vibe Scores and Recommendations
            </h2>
            <p className="mt-3">
              Vibe scores and recommendations are provided for discovery and
              guidance only. They may be based on venue data, time of day,
              activity signals, user activity, editorial review or other
              available information. They should not be treated as guaranteed
              live crowd measurements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white">
              Location and Directions
            </h2>
            <p className="mt-3">
              Maps, distance estimates and directions may rely on third party
              providers. Routes and travel times are estimates only. Users are
              responsible for travelling safely and following local laws,
              transport rules and venue policies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white">
              User Responsibility
            </h2>
            <p className="mt-3">
              Users choose venues, events, offers and activities at their own
              discretion. Vibe2Nite is not responsible for user decisions,
              purchases, bookings, travel, venue experiences or interactions
              with third parties.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white">
              Contact
            </h2>
            <p className="mt-3">
              If you notice incorrect venue or event information, contact:
            </p>
            <p className="mt-2 font-bold text-primary-glow">
              info@vibe2nite.com
            </p>
          </section>
        </div>

        <p className="mt-10 text-sm text-white/40">
          © 2026 Vibe2Nite. All rights reserved. Martin Maughan
        </p>
      </section>
    </main>
  );
}
